import { render, staticRenderFns } from "./page-error.vue?vue&type=template&id=d7320dbc&scoped=true&"
import script from "./page-error.vue?vue&type=script&lang=ts&"
export * from "./page-error.vue?vue&type=script&lang=ts&"
import style0 from "./page-error.vue?vue&type=style&index=0&id=d7320dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7320dbc",
  null
  
)

export default component.exports